import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from '../services/course.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  constructor(private toastrService: ToastrService, private courseService: CourseService, private router: Router, private sanitizer: DomSanitizer,) { }
  public courses:any=[];
  public studentId:any;
  ngOnInit(): void {
    let url = this.router.url.split('/');
    this.studentId = url[1];
    this.getCartedCourses();
  }

  getCartedCourses(){
    this.courseService.getCartedCourses().subscribe(
      (res)=>{
        this.courses = res;
      }
    )
  }

  totalPrice(){
    let price = 0;
    for(let i=0;i<this.courses.length;i++){
      price = price + this.courses[i].price;
    }
    return price;
  }

  removeFromCart(course){
    this.courseService.removeFromCart(course._id).subscribe(
      (res:any)=>{
        this.toastrService.success('Course removed from cart!');
        this.getCartedCourses();
      }
    )
  }

  gstPrice(){
    return this.totalPrice() * 0.18;
  }

  getImage(image){  
    return this.sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  onClickMoreCourses(){
    this.router.navigate(['courses']);
  }

  onClickPayment(){
    this.router.navigate([this.studentId+'/payment']);
    // for(let i=0;i<this.courses.length;i++){
    //   let body = {
    //     category: this.courses[i].category
    //   }
    //   this.courseService.purchaseCourse(this.courses[i]._id, body).subscribe(
    //     (res:any)=>{
    //     }
    //   )
    // }
    // this.router.navigate([`student/${this.studentId}/dashboard`]);
    // this.courseService.purchaseCourse()
  }

}
